const React = require("react");
const ReactRedux = require('react-redux');
const createReactClass = require('create-react-class');

const TextArea = require('../components/TextArea.jsx');
const ApproveRequest = require('./buttons/ApproveRequest.jsx');
const RejectRequest = require('./buttons/RejectRequest.jsx');
const Bypass = require('./buttons/Bypass.jsx');
const StatusBox = require('../components/StatusBox.jsx');
const LoadingBar = require('../components/LoadingBar.jsx');

const actions = require('../_actions.js');
const constants = require('../constants/deployment.js');

const moment = require('moment-timezone');

function getStateTitle(approvalState) {
	switch (approvalState) {
		case constants.APPROVAL_SUBMITTED:
			return 'Pending review by:';
		case constants.APPROVAL_REJECTED:
			return 'Rejected by:';
		case constants.APPROVAL_APPROVED:
			return 'Approved by:';
		case constants.APPROVAL_BYPASSED:
			return 'Approval has been bypassed';
		default:
			return '';
	}
}

function getStateDescription(approvalState) {
	switch (approvalState) {
		case constants.APPROVAL_SUBMITTED:
			return 'Send a request to deploy this release, once approved team members will have the ability to deploy this release. Only one request for approval can be sent at a time, although approval can also be granted by others with the same permission.';
		case constants.APPROVAL_REJECTED:
			return 'This deployment has been rejected.';
		case constants.APPROVAL_BYPASSED:
		case constants.APPROVAL_APPROVED:
			return 'Once approved team members will have the ability to deploy this release. Only one request for approval can be sent at a time, although approval can also be granted by others with the same permissions. e.g. Release managers.';
		default:
			return '';
	}
}

const ApprovalRO = createReactClass({

	getInitialState: function() {
		return {
			rejected_reason_open: this.props.approval_state === constants.APPROVAL_REJECTED
		};
	},

	getRemoveAction: function() {
		if (this.state.rejected_reason_open) {
			return null;
		}
		let extraClasses = "";
		if (this.props.approval_is_loading) {
			extraClasses = ' disabled';
		}
		const icon = this.props.approval_cancel_is_loading ? "fa fa-refresh fa-spin" : "fa fa-times-circle";
		const text = this.props.approval_cancel_is_loading ? 'Removing' : 'Remove';


		return (
			<a
				href={"javascript:void(0);"}
				className={"approval-action btn btn-link pull-right" + extraClasses}
				onClick={this.props.onCancel}
			>
				<i className={icon}></i>{text}
			</a>
		);
	},

	getRejectShowReasonAction: function() {
		return (
			<a href={"javascript:void(0);"} className="btn btn-link" onClick={this.toggleRejectOpen}>
				Reject
			</a>
		);
	},

	getRejectHideReasonAction: function() {
		let extraClasses = "";
		// disabled mode, some other approval action is currently loading
		if (this.props.approval_is_loading) {
			extraClasses = ' disabled';
		}
		return (
			<a href={"javascript:void(0);"} className={"btn btn-link" + extraClasses} onClick={this.toggleRejectOpen}>
				Cancel
			</a>
		);
	},

	toggleRejectOpen: function() {
		this.setState({
			rejected_reason_open: !this.state.rejected_reason_open
		});
	},

	render: function() {
		const props = this.props;

		let error = null;
		if (props.error) {
			error = (
				<div className="alert alert-danger">
					<div className="">
						{props.error}
					</div>
				</div>
			);
		}

		let stateTitle = getStateTitle(props.approval_state);
		let approver_name = props.approver ? props.approver.name : '';
		let approver_role = props.approver ? props.approver.role : '';

		if (props.bypasser) {
			// Tack onto the message as legacy deployments have no bypasser
			stateTitle += ' by:';
			approver_name = props.bypasser.name;
			approver_role = props.bypasser.role;
		}

		let date = '';
		if (props.date_approved) {
			date = props.date_approved.format('DD/MM/YYYY h:mma');
		}

		let removeAction = null;
		let rejectAction = null;
		let rejectCancel = null;
		if (props.can_approve) {
			removeAction = this.getRemoveAction();
			rejectAction = this.getRejectShowReasonAction();
			rejectCancel = this.getRejectHideReasonAction();
		}

		let mainActions = null;
		// If the reject input isn't triggered we show these actions.
		if (!this.state.rejected_reason_open && props.deployer && (props.deployer.id !== props.user.id)) {
			mainActions = (
				<div>
					<ApproveRequest /> {rejectAction}
				</div>
			);
		}

		return (
			<div className="section approval">
				<header><h4>Approval</h4></header>
				<p>
					{getStateDescription(props.approval_state)}
				</p>
				<StatusBox type={props.approval_state}>
					<div>
						{removeAction}
						<div className={"state " + props.approval_state}>
							{stateTitle}
						</div>
					</div>
					<div>{approver_name} <small className="text-uppercase">{approver_role}</small> <small>{date}</small></div>
				</StatusBox>
				<LoadingBar show={props.is_loading} />
				{mainActions}
				<div className={this.state.rejected_reason_open ? "" : "hide"}>
					<div className="form-group">
						<label htmlFor="rejected_reason">Provide a reason why the deployment has been rejected</label>
						<TextArea
							id="rejected_reason"
							value={props.rejected_reason}
							rows="5"
							onChange={props.onRejectReasonChange}
							disabled={props.approval_state === constants.APPROVAL_REJECTED}
						/>
					</div>
					<RejectRequest />
					{rejectCancel}
				</div>
				<div>
					<Bypass />
				</div>
				{error}
			</div>
		);
	}

});

const mapStateToProps = function(state) {
	const current = state.deployment.list[state.deployment.current_id] || {};
	const approver = state.environment.approvers[current.approver_id];

	let date_approved = null;
	if (current.date_approved_unix) {
		date_approved = moment.unix(current.date_approved_unix)
			.tz(state.user.timezone);
	}

	return {
		approval_state: constants.getApprovalState(current.state, approver),
		approval_is_loading: state.approval.is_loading,
		approval_cancel_is_loading: state.approval.cancel_is_loading,
		date_approved: date_approved,
		approver: approver,
		bypasser: current.bypasser,
		deployer: current.deployer,
		can_approve: constants.canApprove(state),
		user: state.user,
		rejected_reason: current.rejected_reason,
		error: state.approval.error,
		is_loading: state.deployment.is_loading
	};
};

const mapDispatchToProps = function(dispatch) {
	return {
		onApproverSelect: function(id) {
			dispatch(actions.setApprover(id));
		},
		onCancel: function() {
			dispatch(actions.cancelApprovalRequest());
		},
		onRejectReasonChange: function(e) {
			dispatch(actions.setRejectReason(e.target.value));
		}
	};
};

module.exports = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(ApprovalRO);
